import React from "react";
import CBtwo from "./CBtwo";
const Btwo= () => {
  return (
    <section className="px-10">
      <h1 className="text-white text-md text-center md:text-left md:text-2xl">
        Basic details
      </h1>
      <section>
        <CBtwo/>
      </section>
    </section>
  );
};

export default Btwo;
